export const getSafeSessionConfig = async (config: any, getToken: () => Promise<string | undefined>) => {
    const token = await getToken();

    if(!config?.API_URL) {
        throw new Error("API URL is not set");
    }

    if(!token) {
        throw new Error("Failed to fetch auth token");
    }

    return {
        API_URL: config.API_URL,
        token
    }
}